import React, { useMemo } from 'react';
import s from './Confetti.css';
const CONFETTI_COLORS = ['#1D3999', '#315FFF', '#151414', '#DCF792'];
export const Confetti = () => {
  const pieces = useMemo(() => Array.from({
    length: 8
  }, (_, i) => {
    const angle = i / 8 * 360;
    const distance = 60 + Math.random() * 80;
    const startX = (Math.random() - 0.5) * 160;
    const tx = Math.cos(angle * Math.PI / 180) * distance;
    const ty = Math.sin(angle * Math.PI / 180) * distance - 40;
    const rot = Math.random() * 720 - 360;
    return {
      key: i,
      style: {
        '--tx': `${tx}px`,
        '--ty': `${ty}px`,
        '--rot': `${rot}deg`,
        left: `${startX}px`,
        animationDelay: `${0.4 + Math.random() * 0.3}s`,
        background: CONFETTI_COLORS[i % CONFETTI_COLORS.length],
        borderRadius: Math.random() > 0.5 ? '50%' : '2px',
        width: `${6 + Math.random() * 6}px`,
        height: `${6 + Math.random() * 6}px`
      }
    };
  }), []);
  return /*#__PURE__*/React.createElement("span", {
    className: s.ConfettiContainer,
    "aria-hidden": "true"
  }, pieces.map(piece => /*#__PURE__*/React.createElement("span", {
    key: piece.key,
    className: s.ConfettiPiece,
    style: piece.style
  })));
};
//# sourceMappingURL=Confetti.js.map